import { Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-how-to-apply',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './how-to-apply.component.html',
  styleUrls: ['./how-to-apply.component.scss']
})
export class HowToApplyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {}

}